import { type ReactElement } from 'react';
import { ApiKeysSection } from './ApiKeysSection';

export function PersonalWorkspaceSubTab(): ReactElement {
  return (
    <div className="space-y-7">
      <ApiKeysSection />
    </div>
  );
}
